// import React from 'react'
import Env from '../../../util/env'

export default (props) => {
  Env.logout (window.location.origin)
  return null
}


// WEBPACK FOOTER //
// ./src/routes/Passport/Logout/index.js